// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//路由
import router from './router'
//引入store
import store from './store'
import axios from "axios";

//引入公共样式
import './assets/css/global.css'
//引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//使用elementui
Vue.use(ElementUI,{ size: 'small', zIndex: 3000 });

//引入富文本编辑器
import quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(quillEditor)

//富文本图片拖拽缩放
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

//富文本扩展图片上传到服务器
import {ImageExtend, QuillWatch} from 'quill-image-extend-module'
Quill.register('modules/ImageExtend', ImageExtend)

//引入自定义带loading的js
import {withLoading} from './utils/withLoading'

Vue.config.productionTip = false


//全局注册，使用方法为:this.$axios
Vue.prototype.$axios=axios;

import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;  // 在页面里可直接用 this.$cookie 调用
//自定义方法
import baseUrl from './request/api/base';
Vue.prototype.$baseUrl = baseUrl; // 将api挂载到vue的原型上复制代码
//引入自定义http  api
import api from './request/index'
Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码
Vue.prototype.$withLoading=withLoading;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js